import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import SunshineTag from 'components/_core/SunshineTag';

import locales from './locales';

const OldIbanBadge: FC = () => (
  <Box
    display="inline-flex"
    flexDirection="row"
    marginLeft="space-8"
    minWidth="80"
  >
    <SunshineTag colorScheme="yellow" size="sm">
      {locales.label}
    </SunshineTag>
  </Box>
);

export default OldIbanBadge;
